import React from 'react';
import PropTypes from 'prop-types';
import UI from '../ui';

const { WrappedTooltip } = UI;

const TagCellRenderer = ({ value }) => {
	if (!value) {
		return '';
	}

	return (
		<div className="common-tags tag-cell-renderer">
			{value.map((tag, index) => (
				<div className="color-bar-parent" key={`color-${tag.OrderTagID}`}>
					<div
						className={`color-bar color-bar-${index}`}
						key={`color-${tag.OrderTagID}`}
						style={{
							background: tag.Color,
						}}
					/>
					<WrappedTooltip
						target={`color-bar-${index}`}
						className="color-bar-tooltip"
						position="right"
						tooltip={tag.Tag}
					/>
				</div>
			))}
		</div>
	);
};

export default TagCellRenderer;

TagCellRenderer.propTypes = {
	props: PropTypes.shape({
		values: PropTypes.arrayOf(
			PropTypes.shape({
				Tag: PropTypes.string,
				Color: PropTypes.string,
			})
		),
	}),
};
